import {accordionScripts} from "./accordion.ts";

window.addEventListener('load', () => {
    accordionScripts();
});